export const HrStatuses = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  LEAVE: 'leave',
} as const;

export type HrStatus = (typeof HrStatuses)[keyof typeof HrStatuses];

export const HR_STATUSES_LIST: HrStatus[] = [
  HrStatuses.ACTIVE,
  HrStatuses.INACTIVE,
  HrStatuses.LEAVE,
];
